import React, { useEffect, useRef, useState } from 'react'
import Footer from '../../shared/footer/footer'
import Navbar from '../../shared/navbar/navbar'
import 'styled-components/macro'
import { Button, Checkbox, Dimmer, Header, Icon, Input, Label, Loader, Menu, Pagination, Table } from 'semantic-ui-react'
import { useDispatch, useSelector } from 'react-redux'
import axios from '../../axios'
import OrderDetails from './orderDetails'
import { ordersActions } from '../../store/orders-slice'

const Orders = () => {
    const [loading, setLoading] = useState(true)
    const [paylo, setpaylo] = useState(false)
    const [orderModal, setOrderModal] = useState({})
    const [payoutD, setPayoutD] = useState(false)
    const [filterOrderID, setFilterOrderID] = useState("")
    const [filterVendorName, setFilterVendorName] = useState("")
    const [pages, setPages] = useState({})
    const [filters, setFilters] = useState({})
    const { userInfo } = useSelector(state => state.user)
    const { successOrders } = useSelector(state => state.orders)
    const { failedOrders } = useSelector(state => state.orders)
    const paymentArray = useRef([])
    const dispatch = useDispatch()
    const loadData = async (cp = 1) => {
        try {
            setLoading(true)
            const config = {
                headers: {
                    Authorization: `Bearer ${userInfo.token}`,
                },
            }
            const { data: { orders, page, pages, errors } } = await axios.get(`/api/order/all?pageNumber=${cp}&pd=${payoutD}&foi=${RfilterOrderID.current.trim()}&fvn=${RfilterVendorName.current.trim()}&fsd=${RfilterDateS.current}&fed=${RfilterDateE.current}&cor=true`, config)//&fsd=${RfilterDateS.current}&fed=${RfilterDateE.current}
            console.log(orders)
            setPages({ current: page, total: pages })
            const success = orders.filter(x => x.order_pass)
            const failed = errors.filter(x => !x.order_pass)
            dispatch(ordersActions.addOrders({ success, failed }))
            setLoading(false)
        } catch (e) {
            alert(e)
            setLoading(false)
        }
    }

    const RfilterOrderID = useRef("")
    const RfilterVendorName = useRef("")

    const RfilterDateS = useRef("")
    const RfilterDateE = useRef("")

    useEffect(() => { loadData() }, [payoutD])

    const handlePageClick = async (page) => {
        loadData(page)
    }

    const handleShowDetails = (e) => {
        const index = parseInt(e.target.name)
        setOrderModal(successOrders[index])
    }
    const handleShowDetails2 = (e) => {
        const index = parseInt(e.target.name)
        setOrderModal(failedOrders[index])
    }

    const handleDateFromChange = (e) => {
        RfilterDateS.current = e.target.value
    }
    const handleDateToChange = (e) => {
        RfilterDateE.current = e.target.value
    }

    const sendSinglePayout = async (paypalOrderID, orderID) => {
        try {

            const config = {
                headers: {
                    Authorization: `Bearer ${userInfo.token}`,
                },
            }
            const { data: resp } = await axios.post("/api/paypal/sendMoney", {
                paypalOrderID,
                orderID
            }, config)
            dispatch(ordersActions.payoutDeliveredByID(paypalOrderID))
        } catch (e) {
            alert(e)
        }
    }

    const handleOrderChange = (e) => {
        /*if (e.key === "Enter") {
            setFilterOrderID(e.target.value)
        }*/
        RfilterOrderID.current = e.target.value
    }
    const handleVendorNameChange = (e) => {
        /*if (e.key === "Enter") {
            setFilterVendorName(e.target.value)
        }*/
        RfilterVendorName.current = e.target.value
    }

    const handlePayAll = async (e) => {
        try {
            e.target.disabled = true
            setpaylo(true)
            const payouts = successOrders.filter(x => !x.payout_delivered)
            const arrPay = [...new Set(paymentArray.current)];
            if (arrPay.length === 0) {
                setpaylo(false)
                e.target.disabled = false
                return;
            }
            for (let i = 0; i < arrPay.length; i++) {
                const paym = payouts.find(p => p._id === arrPay[i])
                await sendSinglePayout(paym.order_id, paym._id)
            }
            setTimeout(() => { window.location.reload() }, 1500)
            setpaylo(false)
        } catch (e) {
            alert(e)
            setpaylo(false)
        }
        e.target.disabled = false
    }

    useEffect(() => {
        loadData()
    }, [])
    const handleCheckPayment = (id, { checked }) => {
        if (checked) {
            paymentArray.current.push(id)
        }
        else if (!checked) {
            paymentArray.current = paymentArray.current.filter(idx => idx !== id)
        }
        console.log("payments:", paymentArray.current)
    }
    useEffect(() => {
        if (loading) {
            paymentArray.current = []
        }
    }, [loading])

    if (loading)
        return <Dimmer active inverted>
            <Loader />
        </Dimmer>

    return (
        <>
            <Navbar />
            <div>

                <main css="max-width:1400px;margin:0 auto; padding:0 36px;">
                    <Table celled selectable>
                        <Table.Header>
                            <Table.Row>
                                <Table.HeaderCell colSpan='10'>
                                    <div css="display:flex;align-items:center;flex-wrap:wrap;">
                                        <div css="padding:5px;"><Checkbox checked={payoutD} onChange={() => setPayoutD(p => !p)} label='Payout delivered' /></div>
                                        <div css="padding:5px;"><Input defaultValue={RfilterOrderID.current} placeholder='Order ID' onChange={handleOrderChange} /></div>
                                        <div css="padding:5px;"><Input defaultValue={RfilterVendorName.current} placeholder='Vendor name' onChange={handleVendorNameChange} /></div>
                                        <div css="padding:5px;">
                                            <Input defaultValue={RfilterDateS.current} type="date" onChange={handleDateFromChange} />
                                            <span css="margin: 0 1rem;">-</span>
                                            <Input defaultValue={RfilterDateE.current} type="date" onChange={handleDateToChange} />
                                        </div>
                                        <div css="padding:5px;"><Button onClick={() => { loadData() }}>Apply filter</Button></div>
                                        <div css="padding:5px;"><Button onClick={() => {
                                            RfilterOrderID.current = "";
                                            RfilterVendorName.current = "";
                                            RfilterDateS.current = "";
                                            RfilterDateE.current = "";
                                            loadData()
                                        }}>Clear filter</Button></div>
                                    </div>
                                </Table.HeaderCell>
                            </Table.Row>
                        </Table.Header>
                        <Table.Header>
                            <Table.Row>
                                <Table.HeaderCell>Pay</Table.HeaderCell>
                                <Table.HeaderCell>Paypal Order ID</Table.HeaderCell>
                                <Table.HeaderCell>Date</Table.HeaderCell>
                                <Table.HeaderCell>Vendor Names</Table.HeaderCell>
                                <Table.HeaderCell>Total</Table.HeaderCell>
                                <Table.HeaderCell>Vendor Commission</Table.HeaderCell>
                                <Table.HeaderCell>Interpowered Commission</Table.HeaderCell>
                                <Table.HeaderCell>Payout delivered</Table.HeaderCell>
                                <Table.HeaderCell>Check</Table.HeaderCell>
                                <Table.HeaderCell></Table.HeaderCell>
                            </Table.Row>
                        </Table.Header>
                        <Table.Body>
                            {successOrders.length > 0 && successOrders.map((x, c) => {
                                const uniques = (arr) => arr.filter((v, i) => arr.indexOf(v) === i)
                                let vendor_names = x.order_items.map(y => { return y.vendor_name })
                                vendor_names = [...new Set(vendor_names)]
                                vendor_names = vendor_names.map(y => { return <div>{y}</div> })
                                return (
                                    <Table.Row key={x.order_id}>
                                        <Table.Cell>{!payoutD && <Checkbox onChange={(e, a) => handleCheckPayment(x._id, a)} />}</Table.Cell>
                                        <Table.Cell>{x.order_id}</Table.Cell>
                                        <Table.Cell>{(new Date(x.order_date)).toLocaleDateString()}</Table.Cell>
                                        <Table.Cell>{vendor_names}</Table.Cell>
                                        <Table.Cell>{x.order_amount}</Table.Cell>
                                        <Table.Cell>{x.commision_sellers}</Table.Cell>
                                        <Table.Cell>{x.commision_admin}</Table.Cell>
                                        <Table.Cell collapsing>
                                            {x.payout_delivered && <Label color="green">YES</Label>}
                                            {!x.payout_delivered && <Label color="red">NO</Label>}
                                        </Table.Cell>
                                        <Table.Cell collapsing>
                                            {x.order_pass && <Label color="green">PASS</Label>}
                                            {!x.order_pass && <Label color="red">FALID</Label>}
                                        </Table.Cell>
                                        <Table.Cell collapsing>
                                            {/*<Button name={c} onClick={handleDetailsClick} circular>Details</Button>*/}
                                            <Button name={c} onClick={handleShowDetails}>Details</Button>
                                            {/*<Button loading={paylo} name={c} onClick={() => handleSendMoney(x.order_id, x._id, c)}>pay</Button>*/}
                                        </Table.Cell>
                                    </Table.Row>
                                )
                            })}

                            {
                                successOrders.length < 1 &&
                                (
                                    <Table.Row>
                                        <Table.Cell colSpan='10'>
                                            <div css="display:flex;align-items:center;justify-content:center;">
                                                <Header as='h2' icon>
                                                    <Icon name='ban' />
                                                    Nothing
                                                </Header>
                                            </div>
                                        </Table.Cell>
                                    </Table.Row>
                                )
                            }
                        </Table.Body>

                        <Table.Footer>
                            <Table.Row>
                                <Table.HeaderCell colSpan='10'>
                                    <div css="display:flex;align-items:center;justify-content:space-between;">
                                        {!payoutD ? <Button loading={paylo} onClick={handlePayAll}>Pay</Button> : <div></div>}
                                        {/* {pages.total > 1 && <Menu pagination>

                                            {[...Array(pages.total).keys()].map((x, c) => {
                                                return <Menu.Item key={c} active={pages.current == c + 1} onClick={() => handlePageClick(c + 1)} as='a'>{c + 1}</Menu.Item>
                                            })}
                                        </Menu>} */}
                                        <Pagination
                                            boundaryRange={0}
                                            defaultActivePage={1}
                                            ellipsisItem={null}
                                            firstItem={null}
                                            lastItem={null}
                                            siblingRange={4}
                                            totalPages={pages.total}
                                            activePage={pages.current}
                                            onPageChange={(e, { activePage }) => handlePageClick(activePage)}
                                        />
                                    </div>
                                </Table.HeaderCell>
                            </Table.Row>
                        </Table.Footer>
                    </Table>

                    <h3 css="text-align:center;margin-top:50px;">Orders flagged as incorrect by the system</h3>
                    <p>The following orders have been flagged because there is a difference between the price of the item and shipping and the transaction charged.</p>
                    <Table css="margin-top:2rem;" celled selectable>
                        <Table.Header>
                            <Table.Row>
                                <Table.HeaderCell>Paypal Order ID</Table.HeaderCell>
                                <Table.HeaderCell>Date</Table.HeaderCell>
                                <Table.HeaderCell>Total</Table.HeaderCell>
                                <Table.HeaderCell>Payout delivered</Table.HeaderCell>
                                <Table.HeaderCell>Check</Table.HeaderCell>
                                <Table.HeaderCell></Table.HeaderCell>
                            </Table.Row>
                        </Table.Header>
                        <Table.Body>
                            {failedOrders.map((x, c) => {
                                return (
                                    <Table.Row key={x.order_id}>
                                        <Table.Cell>{x.order_id}</Table.Cell>
                                        <Table.Cell>{(new Date(x.order_date)).toLocaleString()}</Table.Cell>
                                        <Table.Cell>USD ${x.order_amount}</Table.Cell>
                                        <Table.Cell collapsing>
                                            {x.payout_delivered && <Label color="green">YES</Label>}
                                            {!x.payout_delivered && <Label color="red">NO</Label>}
                                        </Table.Cell>
                                        <Table.Cell collapsing>
                                            {x.order_pass && <Label color="green">PASS</Label>}
                                            {!x.order_pass && <Label color="red">FAILED</Label>}
                                        </Table.Cell>
                                        <Table.Cell collapsing>
                                            <Button name={c} onClick={handleShowDetails2}>Details</Button>
                                        </Table.Cell>
                                    </Table.Row>
                                )
                            })}
                        </Table.Body>

                        {/* <Table.Footer>
                        <Table.Row>
                            <Table.HeaderCell colSpan='10'>
                                <Menu floated='right' pagination>
                                    <Menu.Item as='a' icon>
                                        <Icon name='chevron left' />
                                    </Menu.Item>
                                    <Menu.Item as='a'>1</Menu.Item>
                                    <Menu.Item as='a'>2</Menu.Item>
                                    <Menu.Item as='a'>3</Menu.Item>
                                    <Menu.Item as='a'>4</Menu.Item>
                                    <Menu.Item as='a' icon>
                                        <Icon name='chevron right' />
                                    </Menu.Item>
                                </Menu>
                            </Table.HeaderCell>
                        </Table.Row>
                    </Table.Footer> */}
                    </Table>
                </main>
            </div>

            <Footer />
            <OrderDetails setClose={() => setOrderModal({})} open={Object.keys(orderModal).length > 0} data={orderModal} />
        </>
    )
}
export default Orders